module.exports = __webpack_public_path__ + "static/media/orange.0166a3d4.png";